import { ReactNode } from 'react';
import { ModalDialog } from 'vetrf-ui';

type RemoveModalProps = {
  onClose: () => void;
  onRemove: () => void;
  modalContent: ReactNode;
  removeButtonText?: string;
  cancelButtonText?: string;
};

export const RemoveModal = ({
  onClose,
  onRemove,
  modalContent,
  removeButtonText = 'Удалить',
  cancelButtonText = 'Отмена',
}: RemoveModalProps) => (
  <ModalDialog
    header="Подтверждение"
    onClose={onClose}
    confirmBtn={{
      action: onRemove,
      text: removeButtonText,
      color: 'danger',
      size: 'sm',
    }}
    cancelBtn={{
      text: cancelButtonText,
      size: 'sm',
    }}
  >
    {modalContent}
  </ModalDialog>
);
